/* eslint-disable operator-linebreak */

import langSBNavigation from './modules/navigation';

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    if (event.target.closest('#primary-menu-open')) {
      langSBNavigation.toggleMenu('primary-menu', 'open');
    } else if (
      event.target.closest('.primary-menu-container') &&
      !event.target.closest('.menu-item')
    ) {
      langSBNavigation.toggleMenu('primary-menu', 'close');
    }
  });
});
